import { render, staticRenderFns } from "./custom-template.vue?vue&type=template&id=cd7e28ba"
import script from "./custom-template.vue?vue&type=script&lang=js"
export * from "./custom-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports